// Shared color constants and helpers

export const BIZ_COLORS = { pools: '#b48c3c', riverbend: '#4a8c6a' }

export const STATUS_COLORS = {
  draft: 'rgba(255,255,255,0.3)',
  pending: '#8c4a8c',
  scheduled: '#4a6a8c',
  active: '#b48c3c',
  on_hold: '#e05c5c',
  completed: '#4a8c6a',
  // Cancelled reads as struck-out grey, not alarm-red: it is a dead job, not a
  // problem job. Sharing on_hold's red made the two indistinguishable at a glance.
  cancelled: 'rgba(255,255,255,0.28)',
}

export const OPP_STATUS_COLORS = {
  open: '#4a6a8c',
  bidding: '#b48c3c',
  submitted: '#8c4a8c',
  awarded: '#4a8c6a',
  lost: '#e05c5c',
}

export function getBizColor(bizId) {
  return BIZ_COLORS[bizId] || '#888'
}

export function getStatusColor(status) {
  return STATUS_COLORS[status] || '#888'
}
